module.exports = __webpack_public_path__ + "img/jigou2.2e0c0bfc.png";